export { default } from "./components/Carousel";
